// import Wrapper from "../helpers/Wrapper";
// import DatePicker from "../ui/Datepicker";
// import { useState } from "react";
// import ErrorBoundary from "../../utils/ErrorBoundary";
// import ExportDropdown from "../ui/dropdown/ExportDropdown"
// import IcogzLogo from "../../assets/brand/icogz-logo.svg";
// import GlobalFilter from "../ui/filter/GlobalFilter";

// const Header = ({ identity, name, data, headers, disabled }) => {

//   const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

//   const handleCallback2 = () => {
//     setIsDatePickerOpen(!isDatePickerOpen);
//   };


//   return (
//     <Wrapper>
//       <div className="dashboard_navbar">
//         <a href="#" className="icogz_logo_link">
//           <img src={IcogzLogo} className="icogz_logo" alt="icogz logo" />
//         </a>
//         <div className="flex justify_between" id="top_nav_bar">
//           <div className="left">
//           </div>
//           <div className="right">
//             <div className="flex justify_end align_center">
//               <GlobalFilter />

//               <div className="flex center top_nav_options">
//                 <ErrorBoundary>
//                   <DatePicker
//                     open={isDatePickerOpen}
//                     setOpen={handleCallback2} />
//                 </ErrorBoundary>
//               </div>

//               <div className="flex center top_nav_options" data-html2canvas-ignore={true}>
//                 <ExportDropdown
//                   sectionId={identity}
//                   sectionName={name}
//                   sectionData={data}
//                   sectionDataHeaders={headers}
//                   sectionDisabled={disabled}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Wrapper>
//   );
// };

// export default Header;


import Wrapper from "../helpers/Wrapper";
import DatePicker from "../ui/Datepicker";
import { useState } from "react";
import ErrorBoundary from "../../utils/ErrorBoundary";
import ExportDropdown from "../ui/dropdown/ExportDropdown"
import IcogzLogo from "../../assets/brand/icogz-logo.svg";
import GlobalFilter from "../ui/filter/GlobalFilter";
import CrossGlobalFilter from "../ui/filter/CrossGlobalFilter"; // Import your CrossGlobalFilter
import { useLocation } from "react-router-dom"; // Import useLocation

const Header = ({ identity, name, data, headers, disabled }) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const location = useLocation(); // Get current location

  const handleCallback2 = () => {
    setIsDatePickerOpen(!isDatePickerOpen);
  };

  // Determine which filter to show
  const isCrossSource = location.pathname === "/ri/cross_source";

  return (
    <Wrapper>
      <div className="dashboard_navbar">
        <a href="#" className="icogz_logo_link">
          <img src={IcogzLogo} className="icogz_logo" alt="icogz logo" />
        </a>
        <div className="flex justify_between" id="top_nav_bar">
          <div className="left">
          </div>
          <div className="right">
            <div className="flex justify_end align_center">
              {/* Conditionally render the filter */}
              {isCrossSource ? <CrossGlobalFilter /> : <GlobalFilter />}

              <div className="flex center top_nav_options">
                <ErrorBoundary>
                  <DatePicker
                    open={isDatePickerOpen}
                    setOpen={handleCallback2} />
                </ErrorBoundary>
              </div>

              <div className="flex center top_nav_options" data-html2canvas-ignore={true}>
                <ExportDropdown
                  sectionId={identity}
                  sectionName={name}
                  sectionData={data}
                  sectionDataHeaders={headers}
                  sectionDisabled={disabled}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Header;